import React, { Component } from "react";
import Footer from "../components/footer.component";
import Header from "../components/header.component";
import "../css/project-overview.css";
import projectsData from "../data/projects.data";

import androidIconDark from "../images/web-icons/android-dark.svg";
import webIconDark from "../images/web-icons/web-app-dark.svg";
import apiIconDark from "../images/web-icons/api-dark.svg";
import androidIconLight from "../images/web-icons/android-light.svg";
import webIconLight from "../images/web-icons/web-app-light.svg";
import apiIconLight from "../images/web-icons/api-light.svg";
import googlePlayIcon from "../images/web-icons/google-play.svg";
import openInNew from "../images/web-icons/open-in-new.svg";
import googlePlayIconLight from "../images/web-icons/google-play-light.svg";
import openInNewLight from "../images/web-icons/open-in-new-light.svg";
import chevronDown from "../images/web-icons/chevron-down.svg";
import dateTimeHelper from "../helpers/date-time.helper";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import reportVisitService from "../reporting-visit/report-visit.service";

export default class ProjectOverViewPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overviewBackgroundColor: null,

      title: null,
      category: null,
      icon: null,
      slogan: null,
      fullDescription: null,
      usesCases: [],
      properties: [],
      services: [],
      pricing: null,
      android: null,
      frontend: null,
      backend: null,
      showHeader: false,
      primaryColor: "",
      lightColor: true,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.scrollTo(0, 0);
    const pathnameSplit = window.location.pathname.split("/");
    const projectId = pathnameSplit[pathnameSplit.length - 1];
    const project = projectsData.getProjectDetails(projectId);
    this.setState({
      overviewBackgroundColor: project.overviewBackgroundColor,

      title: project.title,
      category: project.category,
      icon: project.icon,
      slogan: project.slogan,
      fullDescription: project.fullDescription,
      usesCases: project.usesCases,
      properties: project.properties,
      services: project.services,
      pricing: project.pricing,
      android: project.android,
      frontend: project.frontend,
      backend: project.backend,
      primaryColor: project.primaryColor,
      lightColor: project.lightColor,
    });
    document.title =
      project.title + " | David Šimák - A self-taught JAVA/Kotlin developer";
    reportVisitService.report(window.location.pathname, document.title);
  }

  render() {
    const title = this.state.title;
    const iconPath = process.env.PUBLIC_URL + this.state.icon;
    const slogan = this.state.slogan;
    const description = this.state.fullDescription;
    const android = this.state.android;
    const frontend = this.state.frontend;
    const backend = this.state.backend;
    const properties = this.state.properties;
    const usesCases = this.state.usesCases;
    const services = this.state.services;
    const category = this.state.category;
    const pricing = this.state.pricing;
    const primaryColor = this.state.primaryColor;
    const lightColor = this.state.lightColor;

    const responsiveAndroid = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 4,
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
      },
    };

    const responsiveWeb = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 1,
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
      },
    };

    const textColorStyle = {
      color: lightColor ? "#f5f5f5" : "#212121",
    };

    return (
      <div>
        <Header customColor={primaryColor} lightColor={lightColor} />
        <div className="project-top-section">
          <div
            class="project-overview"
            style={{ backgroundColor: primaryColor }}
          >
            <div
              className="project-overview-container"
              style={{ backgroundColor: primaryColor }}
            >
              <div className="project-icon-div">
                <img
                  className="project-icon"
                  title={title}
                  src={iconPath}
                  alt={title}
                />
              </div>
              <label className="project-title" style={{ ...textColorStyle }}>
                {title}
              </label>
              <label
                className="short-description"
                style={{ ...textColorStyle }}
              >
                {slogan}
              </label>
              <label className="project-category" style={{ ...textColorStyle }}>
                {category}
              </label>
              <div class="available_platform">
                {frontend ? (
                  <img
                    title="Web Application"
                    src={lightColor ? webIconLight : webIconDark}
                    alt="Web application"
                  />
                ) : null}

                {backend ? (
                  <img
                    title="API"
                    src={lightColor ? apiIconLight : apiIconDark}
                    alt="API"
                  />
                ) : null}

                {android ? (
                  <img
                    title="Android Application"
                    src={lightColor ? androidIconLight : androidIconDark}
                    alt="Android Application"
                  />
                ) : null}

                {frontend && frontend.url ? (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={frontend.url}
                    style={{ float: "right" }}
                  >
                    <img
                      title="Use web app in new window"
                      src={lightColor ? openInNewLight : openInNew}
                      alt="Use web"
                    />
                  </a>
                ) : null}
                {android && android.availableOn.googlePlayURL ? (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ float: "right" }}
                    href={android.availableOn.googlePlayURL}
                  >
                    <img
                      title="Download Android Application"
                      src={lightColor ? googlePlayIconLight : googlePlayIcon}
                      alt="Google Play"
                    />
                  </a>
                ) : null}
              </div>
            </div>
          </div>
          <label className="see-more">See more details about project</label>
          <div className="see-more-img-container">
            <a href="#about">
              <img
                title="See details about project"
                src={chevronDown}
                alt="See more"
              />
            </a>
          </div>
        </div>
        <div id="about" className="project-section">
          <div className="subsection">
            <label className="subsection-title">Category</label>
            {category}
          </div>
          <div className="subsection">
            <label className="subsection-title">Description</label>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </div>
          {properties && properties.length > 0 ? (
            <div className="subsection">
              <label className="subsection-title">Properties</label>
              <ul>
                {properties.map((property) => (
                  <li className="subsection-array-item">{property}</li>
                ))}
              </ul>
            </div>
          ) : null}

          {usesCases && usesCases.length > 0 ? (
            <div className="subsection">
              <label className="subsection-title">Use cases</label>
              <ul>
                {usesCases.map((useCase) => (
                  <li className="subsection-array-item">{useCase}</li>
                ))}
              </ul>
            </div>
          ) : null}

          {services && services.length > 0 ? (
            <div className="subsection">
              <label className="subsection-title">Services</label>
              {services.map((service) => (
                <label className="subsection-array-item">
                  &bull; {service}
                </label>
              ))}
            </div>
          ) : null}

          {pricing ? (
            <div className="subsection">
              <label className="subsection-title">Pricing</label>
              {pricing}
            </div>
          ) : null}
        </div>
        {android ? (
          <div>
            <hr
              style={{
                backgroundColor: "#BDBDBD",
                height: "1px",
                border: "0px",
                opacity: 1,
              }}
            />
            <div id="android" class="project-section">
              <h1 className="section-title">Android</h1>
              <hr className="section-title-hr" />
              <br />
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={responsiveAndroid}
                ssr={false}
                infinite={false}
                autoPlay={false}
                keyBoardControl={true}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={this.props.deviceType}
                itemClass="carousel-item-padding-40-px"
              >
                {android.images.map((image) => (
                  <div className="carusel-android-item">
                    <div className="carusel-android-item-container">
                      <img
                        alt={image.title}
                        title={image.title}
                        src={process.env.PUBLIC_URL + image.url}
                      />
                      <label>{image.description}</label>
                    </div>
                  </div>
                ))}
              </Carousel>
              <br />
              <hr
                style={{
                  backgroundColor: "#BDBDBD",
                  height: "1px",
                  border: "0px",
                  opacity: 1,
                  width: "calc(100% - 80px)",
                  margin: "40px",
                }}
              />
              <div className="subsection">
                <label className="subsection-title">Permissions</label>
                {android.permissions ? (
                  <ul>
                    {android.permissions.map((permission) => (
                      <li>
                        <b>{permission.name}</b> &bull; {permission.reason}
                      </li>
                    ))}
                  </ul>
                ) : (
                  "This application requires no special permissions to run."
                )}
              </div>
              <div className="subsection">
                <label className="subsection-title">Requirements</label>
                {android.requirements}
              </div>
              <div className="subsection">
                <label className="subsection-title">
                  Minimum supported Android version
                </label>
                {android.requiredAndroidVersion}
              </div>
              <div className="subsection">
                <label className="subsection-title">Supported languages</label>
                {android.languages.supported}
              </div>
              <hr
                style={{
                  backgroundColor: "#BDBDBD",
                  height: "1px",
                  border: "0px",
                  opacity: 1,
                  width: "calc(100% - 80px)",
                  margin: "40px",
                }}
              />
              <div className="subsection">
                <label className="subsection-title">Released on</label>
                {android.versioning.releasedOn ? (
                  <div>
                    {dateTimeHelper.getDateString(
                      android.versioning.releasedOn
                    )}{" "}
                    &bull;{" "}
                    {dateTimeHelper.calculateDuration(
                      android.versioning.releasedOn,
                      new Date()
                    )}
                    {" old"}
                  </div>
                ) : (
                  "Unknown, this project is still under development"
                )}
              </div>
              <div className="subsection">
                <label className="subsection-title">Current version</label>
                {android.versioning.currentVersion}
              </div>
              <div className="subsection">
                <label className="subsection-title">Updated on</label>
                {android.versioning.updatedOn ? (
                  <div>
                    {dateTimeHelper.getDateString(android.versioning.updatedOn)}{" "}
                    &bull;{" "}
                    {dateTimeHelper.calculateDuration(
                      android.versioning.updatedOn,
                      new Date()
                    )}
                    {" ago"}
                  </div>
                ) : (
                  "Unknown, this project is still under development"
                )}
              </div>

              <hr
                style={{
                  backgroundColor: "#BDBDBD",
                  height: "1px",
                  border: "0px",
                  opacity: 1,
                  width: "calc(100% - 80px)",
                  margin: "40px",
                }}
              />
              <div className="subsection">
                <label className="subsection-title">Programming language</label>
                {android.techInformation.language}
              </div>

              <div className="subsection">
                <label className="subsection-title">Logging</label>
                {android.techInformation.logging}
              </div>

              {android.techInformation.database ? (
                <div className="subsection">
                  <label className="subsection-title">Database</label>
                  {android.techInformation.database}
                </div>
              ) : null}

              {android.techInformation.integrations.length > 0 ? (
                <div className="subsection">
                  <label className="subsection-title">Integrations</label>
                  <ul>
                    {android.techInformation.integrations.map((api) => (
                      <li>
                        <a href={api.url}>
                          <b>{api.name}</b>
                        </a>{" "}
                        <ul>
                          {api.purposes.map((purpose) => (
                            <li>{purpose}</li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}

              {android.availableOn.googlePlayURL ? (
                <div
                  class="platform_button"
                  style={{
                    backgroundColor: primaryColor,
                  }}
                >
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={android.availableOn.googlePlayURL}
                  >
                    <img
                      src={lightColor ? googlePlayIconLight : googlePlayIcon}
                      class="fa"
                    />{" "}
                    <p
                      style={{
                        color: lightColor ? "#f5f5f5" : "#212121",
                      }}
                      class="platform_button_text"
                    >
                      Download from Google Play
                    </p>
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        {frontend ? (
          <div>
            <hr
              style={{
                backgroundColor: "#BDBDBD",
                height: "1px",
                border: "0px",
                opacity: 1,
              }}
            />
            <div id="frontend" class="project-section">
              <h1 className="section-title">Frontend</h1>
              <hr className="section-title-hr" />
              <br />
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={responsiveWeb}
                ssr={false}
                infinite={false}
                autoPlay={false}
                keyBoardControl={true}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={this.props.deviceType}
                itemClass="carousel-item-padding-40-px"
              >
                {frontend.images.map((image) => (
                  <div className="carusel-frontend-item">
                    <div className="carusel-frontend-item-container">
                      <img
                        alt={image.title}
                        title={image.title}
                        src={process.env.PUBLIC_URL + image.url}
                      />
                      <label>{image.description}</label>
                    </div>
                  </div>
                ))}
              </Carousel>
              <hr
                style={{
                  backgroundColor: "#BDBDBD",
                  height: "1px",
                  border: "0px",
                  opacity: 1,
                  width: "calc(100% - 80px)",
                  margin: "40px",
                }}
              />
              <div className="subsection">
                <label className="subsection-title">Supported languages</label>
                {frontend.languages.supported}
              </div>
              <hr
                style={{
                  backgroundColor: "#BDBDBD",
                  height: "1px",
                  border: "0px",
                  width: "calc(100% - 80px)",
                  margin: "40px",
                  opacity: 1,
                }}
              />
              <div className="subsection">
                <label className="subsection-title">Released on</label>
                {frontend.versioning.releasedOn ? (
                  <div>
                    {dateTimeHelper.getDateString(
                      frontend.versioning.releasedOn
                    )}{" "}
                    &bull;{" "}
                    {dateTimeHelper.calculateDuration(
                      frontend.versioning.releasedOn,
                      new Date()
                    )}
                    {" old"}
                  </div>
                ) : (
                  "Unknown, this project is still under development"
                )}
              </div>
              <div className="subsection">
                <label className="subsection-title">Current version</label>
                {frontend.versioning.currentVersion
                  ? frontend.versioning.currentVersion
                  : "Unknown"}
              </div>
              <div className="subsection">
                <label className="subsection-title">Updated on</label>
                {frontend.versioning.updatedOn ? (
                  <div>
                    {dateTimeHelper.getDateString(
                      frontend.versioning.updatedOn
                    )}{" "}
                    &bull;{" "}
                    {dateTimeHelper.calculateDuration(
                      frontend.versioning.updatedOn,
                      new Date()
                    )}
                    {" ago"}
                  </div>
                ) : (
                  "Unknown, this project is still under development"
                )}
              </div>

              <hr
                style={{
                  backgroundColor: "#BDBDBD",
                  height: "1px",
                  border: "0px",
                  opacity: 1,
                  width: "calc(100% - 80px)",
                  margin: "40px",
                }}
              />
              <div className="subsection">
                <label className="subsection-title">Programming language</label>
                {frontend.techInformation.language}
              </div>

              <div className="subsection">
                <label className="subsection-title">Framework</label>
                {frontend.techInformation.framework}
              </div>

              <div className="subsection">
                <label className="subsection-title">Package manager</label>
                {frontend.techInformation.packageManager}
              </div>

              <div className="subsection">
                <label className="subsection-title">Web server</label>
                {frontend.techInformation.webServer}
              </div>

              <div className="subsection">
                <label className="subsection-title">Container OS</label>
                {frontend.techInformation.containerOS}
              </div>

              <div className="subsection">
                <label className="subsection-title">Virtualization</label>
                {frontend.techInformation.virtualization}
              </div>

              <div className="subsection">
                <label className="subsection-title">Deployed on</label>
                {frontend.techInformation.deployed}
              </div>

              {frontend.techInformation.integrations.length > 0 ? (
                <div className="subsection">
                  <label className="subsection-title">Integrations</label>
                  <ul>
                    {frontend.techInformation.integrations.map((api) => (
                      <li>
                        <a href={api.url}>
                          <b>{api.name}</b>
                        </a>{" "}
                        <ul>
                          {api.purposes.map((purpose) => (
                            <li>{purpose}</li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}

              {frontend.url ? (
                <div
                  class="platform_button"
                  style={{
                    backgroundColor: primaryColor,
                  }}
                >
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={frontend.url}
                  >
                    <img
                      src={lightColor ? openInNewLight : openInNew}
                      class="fa"
                    />{" "}
                    <p
                      style={{
                        color: lightColor ? "#f5f5f5" : "#212121",
                      }}
                      class="platform_button_text"
                    >
                      Open web app in new window
                    </p>
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        {backend ? (
          <div>
            <hr
              style={{
                backgroundColor: "#BDBDBD",
                height: "1px",
                border: "0px",
                opacity: 1,
              }}
            />
            <div id="api" class="project-section">
              <h1 className="section-title">Backend</h1>
              <hr className="section-title-hr" />
              <br />
              <div className="subsection">
                <label className="subsection-title">Released on</label>
                {backend.versioning.releasedOn ? (
                  <div>
                    {dateTimeHelper.getDateString(
                      backend.versioning.releasedOn
                    )}{" "}
                    &bull;{" "}
                    {dateTimeHelper.calculateDuration(
                      backend.versioning.releasedOn,
                      new Date()
                    )}
                    {" old"}
                  </div>
                ) : (
                  "Unknown, this project is still under development"
                )}
              </div>
              <div className="subsection">
                <label className="subsection-title">Current version</label>
                {backend.versioning.currentVersion
                  ? backend.versioning.currentVersion
                  : "Unknown"}
              </div>
              <div className="subsection">
                <label className="subsection-title">Updated on</label>
                {backend.versioning.updatedOn ? (
                  <div>
                    {dateTimeHelper.getDateString(backend.versioning.updatedOn)}{" "}
                    &bull;{" "}
                    {dateTimeHelper.calculateDuration(
                      backend.versioning.updatedOn,
                      new Date()
                    )}
                    {" ago"}
                  </div>
                ) : (
                  "Unknown, this project is still under development"
                )}
              </div>

              <hr
                style={{
                  backgroundColor: "#BDBDBD",
                  height: "1px",
                  border: "0px",
                  width: "calc(100% - 80px)",
                  margin: "40px",
                  opacity: 1,
                }}
              />
              <div className="subsection">
                <label className="subsection-title">Programming language</label>
                {backend.techInformation.language}
              </div>

              <div className="subsection">
                <label className="subsection-title">Framework</label>
                {backend.techInformation.framework}
              </div>

              <div className="subsection">
                <label className="subsection-title">Logging</label>
                {backend.techInformation.logging}
              </div>

              <div className="subsection">
                <label className="subsection-title">Metrics</label>
                {backend.techInformation.metrics}
              </div>

              <div className="subsection">
                <label className="subsection-title">Container OS</label>
                {backend.techInformation.containerOS}
              </div>

              <div className="subsection">
                <label className="subsection-title">Virtualization</label>
                {backend.techInformation.virtualization}
              </div>

              <div className="subsection">
                <label className="subsection-title">Deployed on</label>
                {backend.techInformation.deployed}
              </div>

              {backend.techInformation.database ? (
                <div className="subsection">
                  <label className="subsection-title">Database</label>
                  {backend.techInformation.database}
                </div>
              ) : null}

              {backend.techInformation.integrations.length > 0 ? (
                <div className="subsection">
                  <label className="subsection-title">Integrations</label>
                  <ul>
                    {backend.techInformation.integrations.map((api) => (
                      <li>
                        <a href={api.url}>
                          <b>{api.name}</b>
                        </a>{" "}
                        <ul>
                          {api.purposes.map((purpose) => (
                            <li>{purpose}</li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        <Footer stylePosition="relative" />
      </div>
    );
  }
}
